// extracted by mini-css-extract-plugin
module.exports = {"closeFullscreen":"closeFullscreen-2bMMJ","closePopup":"closePopup-1Rb5_","closeIcon":"closeIcon-vkhk_"};